import React from "react";

const ModelModal = ({
  isOpen,
  onClose,
  options = [],
  selectedModel,
  setSelectedModel,
  className = "",
  enabledIds = null,
}) => {
  if (!isOpen) return null;

  const enabledSet = Array.isArray(enabledIds) ? new Set(enabledIds) : null;

  const handleSelect = (modelId, isEnabled) => {
    if (enabledSet && !isEnabled) return;
    setSelectedModel && setSelectedModel(modelId);
    onClose && onClose();
  };

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${className}`}> 
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative w-full max-w-lg bg-[#111] border border-white/10 rounded-2xl shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
          <div className="text-sm font-semibold text-white">Select AI Model</div>
          <button
            type="button"
            className="text-gray-300 hover:text-white text-sm px-2 py-1 rounded"
            onClick={onClose}
            title="Close"
          >
            ✕
          </button>
        </div>
        <div className="max-h-[70vh] overflow-y-auto p-3 divide-y divide-white/5">
          {options.map((opt) => {
            const isEnabled = enabledSet ? enabledSet.has(opt.id) : true;
            const isSelected = selectedModel === opt.id;
            return (
              <button
                key={opt.id}
                type="button"
                className={`w-full text-left px-3 py-2 transition-colors ${isSelected ? 'bg-white/5' : ''} ${isEnabled ? 'hover:bg-white/5' : 'opacity-50 cursor-not-allowed'}`}
                onClick={() => handleSelect(opt.id, isEnabled)}
                title={opt.name}
                aria-disabled={!isEnabled}
                disabled={!isEnabled}
              >
                <div className="flex items-start gap-3">
                  <div className="flex-1 min-w-0">
                    <div className="text-white text-sm truncate">{opt.name}</div>
                    {opt.desc && <div className="text-[11px] text-gray-400 truncate">{opt.desc}</div>}
                    {(opt.meta || opt.tags) && (
                      <div className="mt-1 flex flex-wrap items-center gap-2 text-[10px] text-gray-300">
                        {opt.meta?.outputs != null && (
                          <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-white/5 border border-white/10">{opt.meta.outputs} Images</span>
                        )}
                        {opt.meta?.latencySeconds != null && (
                          <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-white/5 border border-white/10">{opt.meta.latencySeconds}s</span>
                        )}
                        {opt.meta?.computeUnits != null && (
                          <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-white/5 border border-white/10">{opt.meta.computeUnits} Compute Units</span>
                        )}
                        {(opt.tags || []).map((t) => (
                          <span key={t} className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-white/5 border border-white/10">{t}</span>
                        ))}
                      </div>
                    )}
                  </div>
                  {isSelected && (
                    <span className="shrink-0 text-[10px] text-black bg-white rounded px-2 py-0.5">Selected</span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ModelModal; 